import { makeAutoObservable } from "mobx";
import { Availability } from "./Availability";
export class Consents {
    constructor(params) {
        this.tosAgreement = params.tosAgreement;
        this.subscribeEmail = params.subscribeEmail;
        this.subscribePhone = params.subscribePhone;
        this.subscribeRestaumaticEmail = params.subscribeRestaumaticEmail;
        this.subscribeRestaumaticPhone = params.subscribeRestaumaticPhone;
        makeAutoObservable(this);
    }
    static empty() {
        return new Consents({
            tosAgreement: false,
            subscribeEmail: false,
            subscribePhone: false,
            subscribeRestaumaticEmail: false,
            subscribeRestaumaticPhone: false,
        });
    }
    static fromStorageData(storageData) {
        if (storageData === null) {
            return Consents.empty();
        }
        return new Consents(storageData);
    }
    get availability() {
        return Availability.boolean({
            TermsOfServiceNotAccepted: !this.tosAgreement,
        });
    }
    get storageData() {
        return {
            tosAgreement: this.tosAgreement,
            subscribeEmail: this.subscribeEmail,
            subscribePhone: this.subscribePhone,
            subscribeRestaumaticEmail: this.subscribeRestaumaticEmail,
            subscribeRestaumaticPhone: this.subscribeRestaumaticPhone,
        };
    }
}
